module.exports = __webpack_public_path__ + "img/tutorial-device-overview-chart.24eb5e38.jpg";